import { render, staticRenderFns } from "./featureDetail.vue?vue&type=template&id=4be3aa76&scoped=true&"
import script from "./featureDetail.vue?vue&type=script&lang=js&"
export * from "./featureDetail.vue?vue&type=script&lang=js&"
import style0 from "./featureDetail.vue?vue&type=style&index=0&id=4be3aa76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3aa76",
  null
  
)

export default component.exports